import { Component, OnInit } from '@angular/core';
import { ProductService } from '../../services/product.service';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { SesionService } from 'src/app/services/sesion.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  paramUrl: any;
  urlEnv: any;
  constructor(public content: ProductService,
    public activeroute: ActivatedRoute,
    public sesion: SesionService) {
  }

  ngOnInit() {
    this.activeroute.queryParams.subscribe( (params): any => {
      this.paramUrl = params['product'];
    });
  }

}
